export const COMMON_METATAG_TAG_TYPES = {
    title: {
        value: "title",
        title: "title",
        data: {},
    },
    meta: {
        value: "meta",
        title: "meta",
        data: {
            content: [],
            name: [
                //
                "author",
                "content-language",
                "copyright",
                "description",
                "keywords",
                "msapplication-TileImage",
                "msapplication-TileColor",
                "subject",
                "theme-color",
                "title",
                "viewport",
            ],
            property: [
                //
                "og:description",
                "og:image",
                "og:title",
                "og:type",
            ],
        },
    },
    link: {
        value: "link",
        title: "link",
        data: {
            as: [
                //
                "audio",
                "document",
                "embed",
                "fetch",
                "font",
                "image",
                "object",
                "script",
                "style",
                "track",
                "video",
                "worker",
            ],
            fetchpriority: [
                //
                "auto",
                "high",
                "low",
            ],
            href: [],
            rel: [
                //
                "alternate",
                "author",
                "shortcut icon",
                "bookmark",
                "canonical",
                "dns-prefetch",
                "external",
                "help",
                "icon",
                "license",
                "manifest",
                "me",
                "modulepreload",
                "next",
                "nofollow",
                "noopener",
                "noreferrer",
                "opener",
                "pingback",
                "preconnect",
                "prefetch",
                "preload",
                "prerender",
                "prev",
                "search",
                "shortlink",
                "stylesheet",
                "tag",
                "apple-touch-icon",
                "apple-touch-startup-image",
            ],
            type: [
                "audio/aac",
                "application/x-abiword",
                "application/x-freearc",
                "image/avif",
                "video/x-msvideo",
                "application/vnd.amazon.ebook",
                "application/octet-stream",
                "image/bmp",
                "application/x-bzip",
                "application/x-bzip2",
                "application/x-cdf",
                "application/x-csh",
                "text/css",
                "text/csv",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-fontobject",
                "application/epub+zip",
                "application/gzip",
                "image/gif",
                "text/html",
                "image/vnd.microsoft.icon",
                "text/calendar",
                "application/java-archive",
                "image/jpeg",
                "text/javascript",
                "application/json",
                "application/ld+json",
                "audio/midi",
                "audio/x-midi",
                "audio/mpeg",
                "video/mp4",
                "video/mpeg",
                "application/vnd.apple.installer+xml",
                "application/vnd.oasis.opendocument.presentation",
                "application/vnd.oasis.opendocument.spreadsheet",
                "application/vnd.oasis.opendocument.text",
                "audio/ogg",
                "video/ogg",
                "application/ogg",
                "audio/opus",
                "font/otf",
                "image/png",
                "application/pdf",
                "application/x-httpd-php",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.rar",
                "application/rtf",
                "application/x-sh",
                "image/svg+xml",
                "application/x-tar",
                "image/tiff",
                "video/mp2t",
                "font/ttf",
                "text/plain",
                "application/vnd.visio",
                "audio/wav",
                "audio/webm",
                "video/webm",
                "image/webp",
                "font/woff",
                "font/woff2",
                "application/xhtml+xml",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "text/xml",
                "application/atom+xml",
                "application/xml",
                "application/vnd.mozilla.xul+xml",
                "application/zip",
                "video/3gpp",
                "audio/3gpp",
                "video/3gpp2",
                "audio/3gpp2",
            ],
        },
    },
};
